import { Badge } from '@/components/ui/badge'
import { Text } from '@/components/ui/text'
import { AppTooltip } from '@components/AppTooltip'
import type { JSX } from 'solid-js'
import { css } from 'styled-system/css'
import { Circle } from 'styled-system/jsx'
import { promptTooltipClass } from './promptTooltipClass'

interface ChipProps {
  color: string
  tooltip?: string
  wrap?: boolean
  children: JSX.Element
}

export default function Chip(props: ChipProps) {
  const badge = (
    <Badge
      justifyContent="center"
      alignItems={props.wrap ? 'flex-start' : 'center'}
      gap='6px'
      px='9px'
      py={props.wrap ? '5px' : undefined}
      h={props.wrap ? 'auto' : '25px'}
      minH={props.wrap ? '25px' : undefined}
      maxW='100%'
      borderRadius='8px'
      style={{ '--c': props.color }}
      class={css({
        bg: 'color-mix(in srgb, var(--c) 13%, var(--colors-gray-surface-bg))',
        borderWidth: '1.5px',
        borderStyle: 'solid',
        borderColor: 'color-mix(in srgb, var(--c) 48%, transparent)',
        color: 'fg.default',
        cursor: 'default',
        transition: 'background 0.15s, border-color 0.15s',
        _hover: {
          bg: 'color-mix(in srgb, var(--c) 20%, var(--colors-gray-surface-bg))',
          borderColor: 'color-mix(in srgb, var(--c) 60%, transparent)',
        },
      })}
    >
      <Circle
        size='6px'
        flexShrink={0}
        mt={props.wrap ? '5px' : undefined}
        style={{ background: 'var(--c)' }}
      />
      <Text
        fontSize='11.5px'
        textTransform='capitalize'
        lineClamp={props.wrap ? undefined : 1}
        style={{
          'font-weight': 600,
          ...(props.wrap ? { 'line-height': '1.3', 'white-space': 'normal' } : {}),
        }}
      >
        {props.children}
      </Text>
    </Badge>
  )

  if (!props.tooltip) return badge

  return (
    <AppTooltip
      delay={900}
      content={props.tooltip}
      contentClass={promptTooltipClass}
    >
      {badge}
    </AppTooltip>
  )
}
